import {
  FETCH_RAMS_DASHBOARD_REQUEST,
  FETCH_RAMS_DASHBOARD_SUCCESS,
  FETCH_RAMS_DASHBOARD_FAILURE,
  FETCH_RAMS_ACTIVE_REQUEST,
  FETCH_RAMS_ACTIVE_SUCCESS,
  FETCH_RAMS_ACTIVE_FAILURE,
  FETCH_RAMS_SETTINGS_REQUEST,
  FETCH_RAMS_SETTINGS_SUCCESS,
  FETCH_RAMS_SETTINGS_FAILURE,
  FETCH_RAMS_PROJECTS_LIST_REQUEST,
  FETCH_RAMS_PROJECTS_LIST_SUCCESS,
  FETCH_RAMS_PROJECTS_LIST_FAILURE,
  FETCH_RAMS_DOCUMENTS_REQUEST,
  FETCH_RAMS_DOCUMENTS_SUCCESS,
  FETCH_RAMS_DOCUMENTS_FAILURE,
  UPLOAD_RAMS_DOCUMENT_REQUEST,
  UPLOAD_RAMS_DOCUMENT_SUCCESS,
  UPLOAD_RAMS_DOCUMENT_FAILURE,
  DELETE_RAMS_DOCUMENT_REQUEST,
  DELETE_RAMS_DOCUMENT_SUCCESS,
  DELETE_RAMS_DOCUMENT_FAILURE,
  TOGGLE_RAMS_DOCUMENT_REQUEST,
  TOGGLE_RAMS_DOCUMENT_SUCCESS,
  TOGGLE_RAMS_DOCUMENT_FAILURE,
  SET_RAMS_STATUS_FILTER,
} from '../reducer'

import {
  fetchDashboard,
  fetchActiveRams,
  fetchSettings,
  fetchProjectsList,
  fetchDocuments,
  uploadDocument,
  removeDocument,
  toggleDocumentActive,
} from '../Services'

export const handleFetchDashboard = () => async (dispatch) => {
  dispatch({ type: FETCH_RAMS_DASHBOARD_REQUEST })
  try {
    var response = await fetchDashboard()
    dispatch({ type: FETCH_RAMS_DASHBOARD_SUCCESS, payload: response.data })
  } catch (error) {
    dispatch({ type: FETCH_RAMS_DASHBOARD_FAILURE, payload: error.message })
  }
}

export const handleFetchActiveRams = (params) => async (dispatch) => {
  dispatch({ type: FETCH_RAMS_ACTIVE_REQUEST })
  try {
    var response = await fetchActiveRams(params)
    dispatch({ type: FETCH_RAMS_ACTIVE_SUCCESS, payload: response.data })
  } catch (error) {
    dispatch({ type: FETCH_RAMS_ACTIVE_FAILURE, payload: error.message })
  }
}

export const handleFetchSettings = () => async (dispatch) => {
  dispatch({ type: FETCH_RAMS_SETTINGS_REQUEST })
  try {
    var response = await fetchSettings()
    var settingsArray = (response.data && response.data.rows) || []
    var values = {}
    var definitions = {}
    settingsArray.forEach(function(setting) {
      var val = setting.value
      // Convert boolean-like values to display text
      if (setting.field_type_id === 5) {
        val = (val === '1' || val === 1 || val === true) ? 'Enabled' : 'Disabled'
      }
      values[setting.token] = val
      definitions[setting.token] = {
        field_type_id: setting.field_type_id,
        title: setting.title,
        help_text: setting.help_text,
        processor_json: setting.processor_json,
        validation_json: setting.validation_json,
      }
    })
    dispatch({ type: FETCH_RAMS_SETTINGS_SUCCESS, payload: { values: values, definitions: definitions } })
  } catch (error) {
    dispatch({ type: FETCH_RAMS_SETTINGS_FAILURE, payload: error.message })
  }
}

export const handleFetchProjectsList = () => async (dispatch) => {
  dispatch({ type: FETCH_RAMS_PROJECTS_LIST_REQUEST })
  try {
    var response = await fetchProjectsList()
    dispatch({ type: FETCH_RAMS_PROJECTS_LIST_SUCCESS, payload: response.data })
  } catch (error) {
    dispatch({ type: FETCH_RAMS_PROJECTS_LIST_FAILURE, payload: error.message })
  }
}

export const handleTableChange = (pagination, filters, sorter) => async (dispatch, getState) => {
  var state = getState()
  var projectFilter = state.screens.RamsControlCentre.active.projectFilter
  var statusFilter = state.screens.RamsControlCentre.active.statusFilter

  var params = {
    page: pagination.current,
    per_page: pagination.pageSize,
  }

  if (projectFilter) {
    params.project_id = projectFilter
  }

  if (statusFilter && statusFilter.length > 0) {
    params['status[]'] = statusFilter
  }

  if (sorter && sorter.field) {
    params.sort_by = sorter.field
    params.sort_order = sorter.order === 'ascend' ? 'asc' : 'desc'
  }

  dispatch(handleFetchActiveRams(params))
}

export const handleProjectFilterChange = (projectId) => async (dispatch, getState) => {
  var state = getState()
  var statusFilter = state.screens.RamsControlCentre.active.statusFilter
  var params = {
    page: 1,
    per_page: 20,
  }
  if (projectId) {
    params.project_id = projectId
  }
  if (statusFilter && statusFilter.length > 0) {
    params['status[]'] = statusFilter
  }
  dispatch(handleFetchActiveRams(params))
}

export const handleStatusFilterChange = (statuses) => async (dispatch, getState) => {
  dispatch({ type: SET_RAMS_STATUS_FILTER, payload: statuses || [] })
  var state = getState()
  var projectFilter = state.screens.RamsControlCentre.active.projectFilter
  var params = {
    page: 1,
    per_page: 20,
  }
  if (projectFilter) {
    params.project_id = projectFilter
  }
  if (statuses && statuses.length > 0) {
    params['status[]'] = statuses
  }
  dispatch(handleFetchActiveRams(params))
}

export const handleFetchDocuments = (params) => async (dispatch) => {
  dispatch({ type: FETCH_RAMS_DOCUMENTS_REQUEST })
  try {
    var response = await fetchDocuments(params)
    dispatch({ type: FETCH_RAMS_DOCUMENTS_SUCCESS, payload: response.data })
  } catch (error) {
    dispatch({ type: FETCH_RAMS_DOCUMENTS_FAILURE, payload: error.message })
  }
}

export const handleUploadDocument = (formData) => async (dispatch) => {
  dispatch({ type: UPLOAD_RAMS_DOCUMENT_REQUEST })
  try {
    var response = await uploadDocument(formData)
    dispatch({ type: UPLOAD_RAMS_DOCUMENT_SUCCESS, payload: response.data })
    return response.data
  } catch (error) {
    var errorMsg = (error.response && error.response.data && error.response.data.message) || 'Failed to upload document'
    dispatch({ type: UPLOAD_RAMS_DOCUMENT_FAILURE, payload: errorMsg })
    throw error
  }
}

export const handleDeleteDocument = (id) => async (dispatch) => {
  dispatch({ type: DELETE_RAMS_DOCUMENT_REQUEST })
  try {
    await removeDocument(id)
    dispatch({ type: DELETE_RAMS_DOCUMENT_SUCCESS, payload: { id: id } })
  } catch (error) {
    var errorMsg = (error.response && error.response.data && error.response.data.message) || 'Failed to delete document'
    dispatch({ type: DELETE_RAMS_DOCUMENT_FAILURE, payload: errorMsg })
    throw error
  }
}

export const handleToggleDocumentActive = (id) => async (dispatch) => {
  dispatch({ type: TOGGLE_RAMS_DOCUMENT_REQUEST })
  try {
    await toggleDocumentActive(id)
    dispatch({ type: TOGGLE_RAMS_DOCUMENT_SUCCESS, payload: { id: id } })
  } catch (error) {
    var errorMsg = (error.response && error.response.data && error.response.data.message) || 'Failed to update document'
    dispatch({ type: TOGGLE_RAMS_DOCUMENT_FAILURE, payload: errorMsg })
    throw error
  }
}
